<template>
  <v-dialog
    v-model="dialog"
    max-width="700px"
  >
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="true"
      autocomplete="off"
    >
      <v-card>
        <v-card-title>
          <span class="headline font-weight-bold">Modifica Smartphone</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.posix"
                      label="Data di acquisto"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.posix"
                    no-title
                    scrollable
                    actions
                    locale="it-IT"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu = false"
                    >OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  label="Smartphone"
                  v-model="model"
                  :search-input.sync="search"
                  :items="searchItems"
                  :loading="isLoading"
                  hide-no-data
                  hide-selected
                  item-text="text"
                  item-value="id"
                  return-object
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="Fornitore"
                  :items="suppliers"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.sup_id"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.serial_number"
                  label="IMEI"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.ean"
                  label="EAN"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  label="Stato"
                  :items="states"
                  v-model="state"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.grade"
                  label="Grado"
                  :rules="[rules.required]"
                  required
                  :readonly="gradeReadOnly"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.desctiption"
                  label="Descrizione"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.cost"
                  label="Costo"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.price"
                  label="Prezzo"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="close"
          >Cancella</v-btn>
          <v-btn
            color="primary"
            text
            @click="save"
          >Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    name: 'EditForm',

    data() {
      return {
        editedItem: {},
        suppliers: [],
        states: [
          'Smartphone Nuovo',
          'Smartphone Usato Art.17',
          'Smartphone Usato Art.36'
        ],
        menu: false,
        search: '',
        model: null,
        searchItems: [],
        isLoading: false,
        gradeReadOnly: false,
        valid: false,
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },

    props: {
      item: { type: Object }
    },

    computed: {
      ...mapGetters([
        'getCellulariEdit'
      ]),
      dialog: {
        get() {
          return this.getCellulariEdit
        },
        set() {
          this.CHANGE_CELLULARI_EDIT(false)
        }
      },
      state: {
        get() {
          if (this.editedItem.grade !== 'Nuovo' && !this.editedItem.is_art_17) {

            this.gradeReadOnly = false
            return 'Smartphone Usato Art.36'
          } else if (this.editedItem.grade !== 'Nuovo' && this.editedItem.is_art_17) {

            this.gradeReadOnly = false
            return 'Smartphone Usato Art.17'
          } else {

            this.gradeReadOnly = true
            return 'Smartphone Nuovo'
          }
        },
        set(val) {
          if (val === 'Smartphone Nuovo') {
            this.editedItem.is_art_17 = true
            this.editedItem.grade = 'Nuovo'
            this.gradeReadOnly = true
          } else if (val === 'Smartphone Usato Art.17') {
            this.editedItem.is_art_17 = true
            this.editedItem.grade = this.editedItem.grade === 'Nuovo' ? null : this.editedItem.grade
            this.gradeReadOnly = false
          } else if (val === 'Smartphone Usato Art.36') {
            this.editedItem.is_art_17 = false
            this.editedItem.grade = this.editedItem.grade === 'Nuovo' ? null : this.editedItem.grade
            this.gradeReadOnly = false
          }
        }
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_CELLULARI_EDIT'
      ]),

      async getSuppliers() {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/suppliers`, this.config)

        this.suppliers = data
      },

      close() {
        this.CHANGE_CELLULARI_EDIT(false)
      },

      async save() {

        if (this.$refs.form.validate()) {

          this.$emit('edit-submit', 'reset')

          const { data } = await axios.post(`${process.env.VUE_APP_API}/smartphones/update`, this.editedItem, this.config)

          if (data.status) {

            this.$emit('edit-submit', 'ok')
            this.close()
          } else {

            this.$emit('edit-submit', 'error')
          }

        }
      },
    },

    watch: {
      dialog(val) {
        val || this.close() && this.CHANGE_CELLULARI_EDIT(false)
      },
      async search(val) {
        if (this.isLoading) return
        if (this.model) return

        this.isLoading = true

        const body = {
          term: val
        }

        const { data } = await axios.post(`${process.env.VUE_APP_API}/smartphones/search-model`, body, this.config)

        this.searchItems = data.map(el => {

          el.text = `${el.brand} ${el.model} ${el.color}, ${el.disk_space} / ${el.ram}`

          return el
        })

        this.isLoading = false
      },
      model(val) {
        if (val) {
          this.editedItem.sma_id = val.id
        }
      },
      async item(val) {

        this.editedItem = val

        const body = {
          term: null
        }

        const { data } = await axios.post(`${process.env.VUE_APP_API}/smartphones/search-model`, body, this.config)

        this.searchItems = data.map(el => {

          el.text = `${el.brand} ${el.model} ${el.color}, ${el.disk_space} / ${el.ram}`

          return el
        })

        const smartphone = await this.searchItems.filter((el) => {
          return this.editedItem.sma_id == el.id
        })

        this.model = smartphone[0]
      }
    },

    async mounted() {
      await this.getSuppliers()

    }
  }
</script>

<style>
</style>